// https://duodian.feishu.cn/sheets/shtcnQM35ekyp9NMTlNLHtIK5nK?sheet=FMQvLu
// 首页数据 price promotionPrice 格式" 92.90"

import { isNumber } from "lodash"

// 促销 2.0  unitSinglePrice unitOriginPrice 格式 9290

export const getItemPriceAndDiscount = item => {
  if (item.additional) {
    item = item.additional
  }
  let price = item.promotionPrice || item.warePrice || item.price || item.unitSinglePrice || item.unitOriginPrice || 0
  price = isNumber(price) ? price / 100 : Number(price)
  let discount =
    (item.unitOriginPrice - item.unitSinglePrice) / 100 ||
    (item.price && item.price - item.promotionPrice) ||
    (item.originalPrice && item.originalPrice - item.promotionPrice) ||
    0
  // category 数据有 promotionWareVO
  if (item.promotionWareVO) {
    price = Number(item.promotionWareVO.unitProPrice) / 100
    discount = Number(item.promotionWareVO.marketPrice - item.promotionWareVO.unitProPrice) / 100
  }
  return {
    price,
    discount
  }
}
export const convertToGAItem = (item, index) => {
  const { commonReqParams } = JSON.parse(localStorage.getItem("commData"))
  const { price, discount } = getItemPriceAndDiscount(item)
  return {
    // item_brand: $item_brand,
    item_id: `${item.sku || item.skuId}`,
    item_name: item.wareName || item.name,
    item_variant: "na",
    item_category: item?.categoryArr?.[0] || "na",
    item_category2: item?.categoryArr?.[1] || "na",
    item_category3: item?.categoryArr?.[2] || "na",
    item_category4: String(commonReqParams.storeId),
    item_category5: isNumber(item.wareStatus) ? String(item.wareStatus) : item.wareStatus?.invalidWareFlag || "0",
    discount,
    price, // num
    quantity: item.quantity || 1, // num, at least 1
    coupon: "na",
    index,
    location_id: getLoationId()
  }
}

export const trackViewItemList = (items = [], itemListId = "", itemListName = "") => {
  const item = items[0]
  if (item?.additional) {
    items = items.map(i => i.additional)
    itemListId = item.parentId
    itemListName = item.layoutName
  }
  if (window?.dataLayer) {
    window.dataLayer.push({
      event: "view_item_list",
      item_list_id: String(itemListId || getItemListId()),
      item_list_name: itemListName || getItemListName(),
      ecommerce: {
        currency: "HKD",
        items: items.map(convertToGAItem)
      }
    })
  }
}

export const getTotalValue = items => {
  return items.reduce((acc, item) => {
    return acc + item.price * item.quantity
  }, 0)
}

export const convertCartItemToGAItem = (item, showItemListId = false) => {
  const { commonReqParams } = JSON.parse(localStorage.getItem("commData"))
  if (item.additional) {
    item.additional.parentId = item.parentId
    item.additional.layoutName = item.layoutName
    item.additional.quantity = item.quantity
    item.additional.index = item.index
    item = item.additional
  }
  // wareNameWithPromotionId 手动加入了 promotionId
  const name = item.wareNameWithPromotionId || item.wareName || item.name
  const itemId = String(item.wareIdWithPromotionId || item.sku || item.skuId)
  const hasBrandName = item.wareName || item.name
  const brand = hasBrandName?.split(" ")?.length > 1 ? hasBrandName.split(" ")[0] : "na"
  const { price, discount } = getItemPriceAndDiscount(item)
  let itemList = {}
  if (showItemListId) {
    itemList = {
      item_list_id: String(item.parentId || getItemListId()),
      item_list_name: item.layoutName || getItemListName()
    }
  }
  return {
    item_brand: brand,
    item_id: itemId,
    item_name: name,
    item_variant: "na",
    item_category: item?.categoryArr?.[0] || "na",
    item_category2: item?.categoryArr?.[1] || "na",
    item_category3: item?.categoryArr?.[2] || "na",
    item_category4: String(commonReqParams.storeId),
    item_category5: isNumber(item.wareStatus) ? String(item.wareStatus) : item.wareStatus?.invalidWareFlag || "0",
    discount,
    price,
    quantity: item.quantity || item.count || 1,
    coupon: "na",
    index: item.index,
    location_id: getLoationId(),
    item_type: item.itemType,
    ...itemList
  }
}

export const getTripleID = () => {
  const { commonReqParams } = JSON.parse(localStorage.getItem("commData"))

  return {
    banner_id: commonReqParams.bannerId,
    vendor_id: String(commonReqParams.venderId),
    store_id: String(commonReqParams.storeId)
  }
}

const LOCATION_MAP = {
  p: "Product Detail",
  d: "Dshop Page",
  category: "Category",
  search: "Search result",
  checkout: "Checkout",
  cart: "My cart",
  order_list: "Order list",
  order_details: "Order detail",
  payment_result: "Payment result"
}

const hashPathMap = {
  "#/search": "Search result",
  "#/checkout": "Checkout",
  "#/cart": "My cart",
  "#/payment_result": "Payment result",
  "#/order_list": "Order list",
  "#/order_details": "Order detail"
}

const handleSpecialhashPath = path => {
  Object.keys(hashPathMap).forEach(key => {
    if (path.includes(key)) {
      path = hashPathMap[key]
    }
  })
  return path
}

export const getLoationId = () => {
  const path = window.location.pathname
  const hash = window.location.hash
  if (hash) return handleSpecialhashPath(hash) || "Banner home"
  const secondPath = path.split("/")[2]
  if (!secondPath) return "Banner home"
  return LOCATION_MAP[secondPath] || secondPath
}

export const getItemListId = () => {
  return getPageCategory().split(" ").join("_").toLocaleLowerCase()
}

export const getPageCategory = getLoationId
export const getItemListName = getLoationId
